import { TextField } from '@mui/material'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import {
  MultipleChoiceAnswerWithRelated,
  PromptWithRelated
} from '../../models/inspections'
import { useUpdateInspectionPromptMutation } from '../../redux/api/inspectionApi'

export const AnswerTechnicianNotes = ({
  setIsSubmitting,
  answer,
  prompt
}: {
  setIsSubmitting: (isSubmitting: boolean) => void
  answer: MultipleChoiceAnswerWithRelated
  prompt: PromptWithRelated
}) => {
  const { accessToken } = useAccessTokenAndShopId()

  const [update] = useUpdateInspectionPromptMutation()

  const handleNotesBlur = async (technicianNotes: string) => {
    setIsSubmitting(true)
    await update({
      authorization: accessToken,
      promptEntry: {
        ...prompt,
        info: { ...prompt.info!, technicianNotes }
      }
    })
    setIsSubmitting(false)
  }

  return (
    <>
      <TextField
        sx={{ mt: 1 }}
        multiline
        defaultValue={prompt.info?.technicianNotes || ''}
        onBlur={(event) => handleNotesBlur(event.target.value)}
        label="Technician Notes"
        required={answer.info!.requiresNotes || prompt.info!.requiresNotes}
      />
    </>
  )
}
